import BreakDto from '@/models/Shared/BreakDto';

export default class ShiftViewModel {
    id = '';
    updatedAt: Date;
    bookingRoleId = '';
    startAtDate = '';
    startAtTime = '';
    endAtTime = '';
    quantity = 1;
    break = 20;
    isPaidBreak = false;
}